import { useEffect, useState } from "react";

import {
    PartExchange,
    getPreliminaryAppraisal,
    partExchangeDeleteCookies,
} from "services/motorpoint/partExchange";
import { PartExchangeQuestionAnswersResponse } from "services/motorpoint/partExchangeQuestions";
import { logError } from "utils/logger";

const usePartExchangeData = () => {
    const [partExchangeData, setPartExchangeData] = useState<
        PartExchange | PartExchangeQuestionAnswersResponse.AnswersResponse | undefined
    >(undefined);

    const getPartExchangeData = async (): Promise<PartExchange | null> => {
        try {
            const data = await getPreliminaryAppraisal();
            if (data?.PartExchange) {
                setPartExchangeData(data.PartExchange);
                return data.PartExchange;
            }

            return null;
        } catch (error) {
            logError("Failed to receive part exchange data.", error);

            return null;
        }
    };

    useEffect(() => {
        getPartExchangeData();
    }, []);

    const resetPartExchangeData = async () => {
        await partExchangeDeleteCookies();
        setPartExchangeData(undefined);
    };

    return {
        partExchangeData,
        setPartExchangeData,
        getPartExchangeData,
        resetPartExchangeData,
    };
};

export default usePartExchangeData;
